export const storageKeys = {
    AdminData: 'AdminData',
    authtoken: 'authtoken'
}